import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Thumbs, FreeMode, Navigation } from "swiper";
import { motion } from "framer-motion";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';
import "./ProductPage.css";
// import ProductRecs from './ProductRecs/ProductRecs';
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import mainApi from "../../assets/api/MainApi";
import MiniPreloader from "../MiniPreloader/MiniPreloader";
import NotFoundBlock from "../NotFoundBlock/NotFoundBlock";
import {
  buildCategoryPath,
  compareOptions,
  getCorrectWordForm,
  getFinalPrice,
  parseParameterValue,
  parsePrice,
  parseTitleForParts,
} from "../../assets/utils/utils";
import { ARTICL_NAME, CART_MAIN_LINK, CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT, MAIN_URL, OPEN_ITEM_REQUEST, RECENTLY_VIEW_LS_KEY } from "../../assets/utils/constants";
import { ArrowIcon, CrossIcon } from "../../assets/icons/icons";
import { ConfigContext } from "../../assets/contexts/configContext";
import { CartContext } from "../../assets/contexts/cartContext";
import { ContactContext } from "../../assets/contexts/contactContext";
import InfoLine from "./InfoLine/InfoLine";
import ProductCardHero from "../Catalog/ProductCardHero/ProductCardHero";
import useWindowSize from "../../assets/hooks/useWindowSize";
import ImageWithBackground from "../ImageWithBackground/ImageWithBackground";
import FullScreen from "./FullScreen/FullScreen";

function ProductPage({
  // handleAddToCart,
  // cart,
  // handleRemoveFromCart,
  item_id,
  levels,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const cart_context = useContext(CartContext)
  const {
    cart,
    handleAddToCart,
    handleRemoveFromCart,
    // setCart,
  } = cart_context

  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { CONSTANTS } = initialConstants
  const { SHOW_AMOUNT_IN_STOCK_IN_GOODS_PAGE = true, CONTACT_US_CART_BTN = "Request price" } = CONSTANTS
  const { SHOP_ID_FOR_API, SHOP_NAME } = initialConstants

  const [preloaders, setPreloaders] = useState({
    item: true,
  });
  const [product, setProduct] = useState(undefined);
  const [selectedOptions, setSelectedOptions] = useState(null)
  const [promotedProducts, setPromotedProducts] = useState(undefined);
  const removeCartRef = useRef(null);
  const [my_swiper, set_my_swiper] = useState({});

  const reversedArray = product && product.categories && product.categories[0] && product.categories[0].parents ? [...product.categories[0].parents].reverse() : [];

  const in_stock = product ? product.options.length === 1 ? selectedOptions[0].in_stock : product.price_data.in_stock : null

  const { setContactPopupOpen: setContactOpen } = useContext(ContactContext);
  const isContactUsOnly = product && product.parameters && product.parameters.length > 0 ? product.parameters.some(param => param.name === '_contact-us-only' && param.value === true) : false;

  const price = product ? selectedOptions && selectedOptions.length === 1 ? selectedOptions[0].price : product.price_data.price : null
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  useEffect(() => {
    if (!item_id || !levels) return;

    console.log({ levels, item_id });
    // const pathname = location.pathname.split("/");
    // const id = pathname[pathname.length - 1];
    setPreloaders((prevState) => ({
      ...prevState,
      item: true,
    }));
    mainApi
      .getExactProduct({
        shop_id: SHOP_ID_FOR_API,
        _id: item_id,
      })
      .then((res) => {
        console.log(res);
        setProduct(res);
        const options = res.options
        if (options && options.length > 0) {

          let initial_options = searchParams.get("options")
          if (!initial_options) {
            setSelectedOptions(options.map((option) => {
              return {
                name: option.name,
                value: option.values[0].value,
                in_stock: option.values[0].in_stock,
                price: option.values[0].price,
              }
            }))
          } else {
            setSelectedOptions(JSON.parse(initial_options))
          }
        }
        getPromotedProducts({
          category: res.categories?.length > 0 ? res.categories[0]._id : null,
        });
        window.dataLayer.push({
          ecommerce: {
            currencyCode: "USD",
            detail: {
              products: [
                {
                  id: res?._id,
                  name: `${res?.name} ${res?._id}`,
                  //   category: res
                  //     ? `${res.category.name}/${res.sub_category.title.ru}`
                  //     : "",
                  // price: getFinalPrice(product.options && product.options.length === 1 ? {
                  //   price: product.options[0].price,
                  //   ...product.price_data,
                  // } : product.price_data),
                  //   variant: res.sizes ? res.sizes[0].name : "Без размера",
                  options: res.options,
                },
              ],
            },
          },
        });
      })
      .catch((err) => {
        console.log(err);
        setPreloaders((prevState) => ({
          ...prevState,
          item: false,
        }));
      });
  }, [item_id]);


  function getPromotedProducts({ category }) {
    mainApi
      .getItems({
        shop_id: SHOP_ID_FOR_API,
        category,
        limit: 10,
      })
      .then((res) => {
        console.log(res.data);
        setPromotedProducts(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloaders((prevState) => ({
          ...prevState,
          item: false,
        }));
      });
  }

  function removeFromCart() {
    const product_to_card = {
      ...product,
      // selected_size: selectedSize,
      options: selectedOptions,
    };
    console.log(product_to_card);
    handleRemoveFromCart(product_to_card, true);
  }
  const inCart = product && cart && cart.find((cart_item) => {
    if (cart_item._id !== product._id) {
      return false; // Skip items with a different ID early
    }

    // If the item has options and selectedOptions are provided, compare them
    if (cart_item.options && cart_item.options.length > 0 && selectedOptions && selectedOptions.length > 0) {
      const comparisonResult = compareOptions(selectedOptions, cart_item.options);
      console.log(comparisonResult, cart_item)
      return comparisonResult.differences.length === 0;
    } else {
      // If there are no options to compare, just check the _id
      return true;
    }
  });
  const navigate = useNavigate();
  function addToCart() {
    if (inCart) {
      navigate(`/${CART_MAIN_LINK}`);
      return;
    }
    const product_to_card = {
      ...product,
      options: selectedOptions,
      // selected_size: selectedSize,
      count: 1,
    };
    console.log(product_to_card);
    handleAddToCart(product_to_card);
  }

  const options = product ? product.options : []

  function handleSelectOption({ option }) {
    setSelectedOptions(prevValue => prevValue.map((item, i) => {
      if (item.name !== option.name) return item
      return {
        ...item,
        value: option.value,
        in_stock: option.in_stock,
        price: option.price,
      }
    }))
  }

  function openContactPopup() {
    setContactOpen(true);
    localStorage.setItem(OPEN_ITEM_REQUEST, product._id)
  }

  function parseString(name) {
    // Разбиваем строку по запятым, удаляем пробелы, а затем соединяем элементы с точкой
    const items = product?.parameters?.find((item2) => item2.name === name) && product.parameters ? product.parameters?.find((item2) => item2.name === name)?.value.split(',').map((item) => item.trim()) : ''
    return items ? items?.map((item, index) => (
      <Fragment key={index}>
        {item}
        {index < items.length - 1 && <span className="dot">•</span>} {/* Add dot between items */}
      </Fragment>
    )) : null
  }

  // console.log(product?.parameters)
  const recentlyView = JSON.parse(localStorage.getItem(RECENTLY_VIEW_LS_KEY)) || []

  const [visibleCount, setVisibleCount] = useState(2);
  const [recentlyViewArray, setRecentlyViewArray] = useState([]);
  // Функция для увеличения видимых карточек
  const loadMore = () => {
    setVisibleCount(visibleCount + recentlyView.length - 3);
  };
  const { width } = useWindowSize()

  useEffect(() => {
    mainApi
      .getManyItems({
        data: {
          shop_id: SHOP_ID_FOR_API,
          ids: recentlyView,
        },
      })
      .then((res2) => {
        console.log(res2)
        setRecentlyViewArray(res2.data)
      })
      .catch((err) => {
        console.log(err);
      });
  }, [])

  const [isFull, setFull] = useState(false)

  const [isLiked, setIsLiked] = useState(false);

  // Utility functions for managing local storage
  const getLikedProducts = () => JSON.parse(localStorage.getItem('likedProducts')) || [];
  const saveLikedProducts = (likedProducts) => localStorage.setItem('likedProducts', JSON.stringify(likedProducts));

  // Check if the product is liked on component mount
  useEffect(() => {
    if (!product) return
    const likedProducts = getLikedProducts();
    setIsLiked(likedProducts.includes(product._id));
  }, [product]);

  // Handle like button click
  const handleLikeClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const likedProducts = getLikedProducts();
    if (likedProducts.includes(product._id)) {
      // Remove from liked products
      const updatedLikedProducts = likedProducts.filter((id) => id !== product._id);
      saveLikedProducts(updatedLikedProducts);
      setIsLiked(false);
    } else {
      // Add to liked products
      likedProducts.push(product._id);
      saveLikedProducts(likedProducts);
      setIsLiked(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>{SHOP_NAME} - ...</title>
      </Helmet>
      {preloaders.item ? (
        <div className="product-page__preloader">
          <MiniPreloader />
        </div>
      ) : product ? (
        <div className="product-page">
          <Helmet>
            <title>{SHOP_NAME} - {product.name && product.name.length > 0 ? parseTitleForParts(product.name).title : ``}{product.name && product.name.length > 0 && parseTitleForParts(product.name).subtitle ? ` ` + parseTitleForParts(product.name).subtitle : ``}</title>
          </Helmet>
          {/* <p>{category_type} {sub_category_type} {id}</p> */}
          <div className="product-page__content">
            <div className="product-page__crumbs">
              {reversedArray ?
                reversedArray.map((category, i) => (
                  <Link
                    to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(
                      reversedArray,
                      i
                    )}`}
                  >
                    <p className="product-page__crumb">
                      {category.name}
                      {i !== reversedArray.length - 1 ? ` ›` : ""}
                    </p>
                  </Link>
                )) : null}
            </div>

            <div className="product-page__item">
              <div className={`product-page__photos ${product.files && product.files.length > 1 ? '' : 'product-page__photos_once'}`}>
                {product.files && product.files.length > 1 ?
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    slidesPerView={width <= 500 ? 'auto' : 5}
                    spaceBetween={10}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Thumbs]}
                    className="photo-slider__cards photo-slider__cards_vertical"
                    direction={width <= 500 ? 'horizontal' : 'vertical'}
                  // breakpoints={{
                  //   1000: {
                  //     slidesPerView: 6,
                  //     spaceBetween: 14,
                  //   },
                  //   500: {
                  //     slidesPerView:'auto',
                  //     spaceBetween: 16,
                  //   }
                  // }}
                  >
                    {product.files && product.files.length > 0 ?

                      product.files.map((item, i) => (
                        <SwiperSlide
                          className={`photo-slider__card photo-slider__card_thumbs`}
                          key={`photo-slider__card${i}`}
                        >
                          <ImageWithBackground
                            // onClick={(e) => {
                            //     // e.target?.requestFullscreen()
                            //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                            // }}
                            className="photo-slider__card-img"
                            src={item.urls.orig}
                            isVideo={item?.metadata?.first_frame_db}
                            alt=""
                            metadata={item.metadata}
                          />
                        </SwiperSlide>
                      ))
                      :
                      <SwiperSlide
                        className="photo-slider__card"
                      >
                        <img
                          // onClick={(e) => {
                          //     // e.target?.requestFullscreen()
                          //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                          // }}
                          className="photo-slider__card-img"
                          src={IMG_PLACEHOLDER_PRODUCT}
                          alt=""
                        ></img>
                      </SwiperSlide>
                    }
                  </Swiper>
                  : null}
                <div className="product-page__main-photos">
                  {product.files && product.files.length > 1 ?
                    <button className="product-page__swiper-arrow-btn product-page__swiper-arrow-btn_left" type="button"
                      onClick={() => {
                        if (my_swiper) {
                          my_swiper.slidePrev();
                        }
                      }}>
                      <ArrowIcon
                        mainClassName={'product-page__swiper-arrow-icon'}
                        fillClassName={'product-page__swiper-arrow-icon-fill'}
                      />
                    </button>
                    : null}

                  <Swiper
                    slidesPerView={'auto'}
                    // spaceBetween={10}
                    mousewheel={{
                      forceToAxis: true,
                    }}
                    modules={[Mousewheel, Thumbs, Navigation, Pagination]}
                    thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                    // preventInteractionOnTransition={true}
                    className="photo-slider__cards"
                    onInit={(ev) => {
                      set_my_swiper(ev);
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    loop
                    breakpoints={{
                      1000: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                      },
                    }}
                  >
                    {product.files && product.files.length > 0 ?
                      product.files && product.files.length > 1 ?
                        product.files.map((item, i) => (

                          <SwiperSlide
                            className="photo-slider__card"
                            key={`photo-slider__card${i}`}
                            onClick={() => setFull(true)}
                          >
                            <ImageWithBackground
                              // onClick={(e) => {
                              //     // e.target?.requestFullscreen()
                              //     // setFullScreenSrc(`${MAIN_URL}/get-file/${item?.urls?.orig}`)
                              //     
                              // }}

                              className="photo-slider__card-img"
                              src={item.urls.orig}
                              isVideo={item?.metadata?.first_frame_db}
                              alt=""
                              metadata={item.metadata}
                            />
                          </SwiperSlide>
                        ))
                        : product.files.map((item, i) => (
                          <SwiperSlide
                            className="photo-slider__card"
                            key={`photo-slider__card${i}`}
                            onClick={() => setFull(true)}
                          >
                            <ImageWithBackground
                              // onClick={(e) => {
                              //     // e.target?.requestFullscreen()
                              //     // setFullScreenSrc(`${MAIN_URL}/get-file/${item?.urls?.orig}`)
                              //     
                              // }}

                              className="photo-slider__card-img"
                              src={item.urls.orig}
                              isVideo={item?.metadata?.first_frame_db}
                              alt=""
                              metadata={item.metadata}
                            />
                          </SwiperSlide>
                        ))
                      :
                      <SwiperSlide
                        className="photo-slider__card"
                      >
                        <img
                          // onClick={(e) => {
                          //     // e.target?.requestFullscreen()
                          //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                          // }}
                          className="photo-slider__card-img"
                          src={IMG_PLACEHOLDER_PRODUCT}
                          alt=""
                        ></img>
                      </SwiperSlide>
                    }
                  </Swiper>
                  {product.files && product.files.length > 1 ?
                    <button className="product-page__swiper-arrow-btn product-page__swiper-arrow-btn_right" type="button"
                      onClick={() => {
                        if (my_swiper) {
                          my_swiper.slideNext();
                        }
                      }}>
                      <ArrowIcon
                        mainClassName={'product-page__swiper-arrow-icon'}
                        fillClassName={'product-page__swiper-arrow-icon-fill'}
                      />
                    </button>
                    : null}
                </div>

              </div>
              <div className="product-page__info">
                <button className={`product-page__like ${isLiked ? 'product-page__like_active' : ''}`} type='button' onClick={handleLikeClick}>
                  <svg className='product-page__like-icon' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='product-page__like-icon-fill-and-stroke' d="M17.5173 3C21.3979 3 24 6.725 24 10.1938C24 17.235 13.1968 23 13 23C12.8032 23 2 17.235 2 10.1938C2 6.725 4.60211 3 8.48267 3C10.701 3 12.1579 4.13125 13 5.13875C13.8421 4.13125 15.299 3 17.5173 3Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <h2 className={`product-page__name`}>{product.name && product.name.length > 0 ? parseTitleForParts(product.name).title : ` `}</h2>
                <p className={`product-page__subname`}>{product.name && product.name.length > 0 ? parseTitleForParts(product.name).subtitle : ` `}</p>
                {product.description ?
                  <h3 className="product-page__description">
                    {product.description}
                  </h3>
                  : null}
                <div className="product-page__parameters-lines-block">
                  {product?.parameters && product?.parameters?.find((item2) => item2.name === 'Condition') ?

                    <div className="product-page__parameters-lines">

                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M4.99946 11.2554L3.68347 9.77137C3.54421 9.61434 3.4579 9.41747 3.43675 9.20865C3.4156 8.99983 3.46069 8.78966 3.56563 8.60789L4.84484 6.39213C4.94978 6.21037 5.10925 6.06623 5.30066 5.98014C5.49207 5.89404 5.70572 5.87036 5.91133 5.91243L7.85463 6.31006L9.14431 5.56543L9.77153 3.68377C9.83791 3.48466 9.96524 3.31148 10.1355 3.18876C10.3058 3.06604 10.5103 3 10.7202 3H13.2787C13.4886 3 13.6932 3.06604 13.8634 3.18876C14.0337 3.31148 14.161 3.48466 14.2274 3.68377L14.8546 5.56543L16.1443 6.31006L18.0876 5.91243C18.2932 5.87036 18.5069 5.89404 18.6983 5.98014C18.8897 6.06623 19.0491 6.21037 19.1541 6.39213L20.4333 8.60785C20.5383 8.78962 20.5833 8.9998 20.5622 9.20861C20.541 9.41743 20.4547 9.6143 20.3155 9.77133L18.9995 11.2554V12.7446L20.3155 14.2286C20.4547 14.3857 20.541 14.5825 20.5622 14.7914C20.5833 15.0002 20.5382 15.2103 20.4333 15.3921L19.1541 17.6078C19.0491 17.7896 18.8897 17.9337 18.6982 18.0198C18.5068 18.1059 18.2932 18.1296 18.0876 18.0875L16.1442 17.6899L14.8546 18.4344L14.2274 20.3162C14.161 20.5153 14.0337 20.6885 13.8634 20.8112C13.6931 20.9339 13.4886 21 13.2787 21H10.7202C10.5103 21 10.3058 20.934 10.1355 20.8112C9.96525 20.6885 9.83791 20.5153 9.77155 20.3162L9.14431 18.4345L7.85468 17.6899L5.91132 18.0876C5.70571 18.1297 5.49206 18.106 5.30066 18.0199C5.10925 17.9338 4.94978 17.7896 4.84484 17.6079L3.5656 15.3921C3.46067 15.2104 3.41558 15.0002 3.43673 14.7914C3.45789 14.5826 3.54421 14.3857 3.68347 14.2287L4.99946 12.7446V11.2554Z" stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <p className='product-page__condition'>{parseString('Condition')}</p>
                    </div>
                    : null}
                  {product?.parameters && product?.parameters?.find((item2) => item2.name === 'Capacity') ?
                    <div className="product-page__parameters-lines">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.34006 5H15.6599C16.2952 5 16.9172 5.18115 17.4531 5.52218C17.9272 5.82384 18.3174 6.24023 18.5878 6.73279C18.8582 7.22535 19 7.77816 19 8.34006V15.6599C19 16.2218 18.8582 16.7746 18.5879 17.2672C18.3175 17.7598 17.9272 18.1762 17.4531 18.4778C16.9172 18.8189 16.2952 19 15.6599 19H8.34006C7.70485 19 7.0828 18.8189 6.5469 18.4778C6.07284 18.1762 5.68255 17.7598 5.41216 17.2672C5.14176 16.7747 5 16.2218 5 15.6599V8.34006C5 7.77817 5.14176 7.22535 5.41215 6.73279C5.68254 6.24023 6.07282 5.82384 6.54687 5.52218C7.08279 5.18114 7.70484 5 8.34006 5Z" stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M16.669 18.8428L16.0024 21.6067C15.941 21.8613 15.7958 22.0878 15.5901 22.2498C15.3843 22.4118 15.1301 22.4999 14.8683 22.4999H9.12889C8.86704 22.4999 8.61281 22.4118 8.40709 22.2498C8.20138 22.0878 8.05614 21.8613 7.99475 21.6067L7.32812 18.8428" stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.32812 5.1571L7.99475 2.39313C8.05614 2.13858 8.20138 1.91209 8.40709 1.75009C8.61281 1.58809 8.86704 1.5 9.12889 1.5H14.8683C15.1301 1.5 15.3843 1.58808 15.5901 1.75009C15.7958 1.91209 15.941 2.13858 16.0024 2.39313L16.669 5.1571" stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <p className='product-page__condition'>{parseString('Capacity')}</p>
                    </div>
                    : null}
                  {product?.parameters?.find((item2) => item2.name === ARTICL_NAME) ?
                    <div className="product-page__parameters-lines product-page__parameters-lines_reference">
                      <p className="product-card__button__reference-title">Reference:</p>
                      <p className='product-card__button__reference-value'>{product?.parameters?.find((item2) => item2.name === ARTICL_NAME) ? product?.parameters?.find((item2) => item2.name === ARTICL_NAME).value : ''}</p>
                    </div>
                    : null}

                </div>


                <div className="product-page__condition-and-price">
                  {price.length > 0 && price > 1 ?
                    product.price_data.discount && product.price_data.discount > 0 ?
                      <h3 className='product-page__price-value'>
                        <span className='product-page__price-value-discounted'>{parsePrice(Number(price), 'USD')}</span>
                        {parsePrice(Number(price) - Number(price) / 100 * Number(product.price_data.discount), 'USD')}
                      </h3>
                      :
                      <h3 className='product-page__price-value'>{parsePrice(price, 'USD')}</h3>
                    : <div />}


                  <div className="product-page__buy">
                    {product.price_data.discount && product.price_data.discount > 0 ?
                      <h3 className='product-page__price-discount'>-{product.price_data.discount}%</h3>
                      :
                      null
                    }
                    <div
                      className={`product-info__add-to-cart-box ${inCart ? "product-info__add-to-cart-box_in-cart" : ""
                        }`}
                    >
                      {isContactUsOnly ?
                        <button
                          className={`product-page__purchase-btn`}
                          type="button"
                          onClick={openContactPopup}
                        >
                          <h3 className="product-page__purchase-btn-text">
                            {/* {"Связаться с нами"} */}
                            {CONTACT_US_CART_BTN ? CONTACT_US_CART_BTN : "Request price"}
                          </h3>
                        </button>
                        :
                        in_stock ?
                          price.length > 0 && price > 1 ?
                            <button
                              className={`product-page__purchase-btn`}
                              type="button"
                              onClick={addToCart}
                            >
                              <h3 className="product-page__purchase-btn-text">
                                {" "}
                                {inCart ?
                                  "In cart ›"
                                  :
                                  <>
                                    Add to cart
                                  </>
                                }
                              </h3>
                            </button>
                            :
                            <button
                              className={`product-page__purchase-btn`}
                              type="button"
                              onClick={openContactPopup}
                            >
                              <h3 className="product-page__purchase-btn-text">
                                Request Price
                              </h3>
                            </button>
                          :
                          <div
                            className={`product-page__purchase-btn product-page__purchase-btn_type_not-in-stock`}
                          >
                            <h3 className="product-page__purchase-btn-text">
                              {"Not in stock"}
                            </h3>
                          </div>
                      }


                      <motion.button
                        initial={{
                          width: "0",
                          padding: "0",

                          visibility: "hidden",
                        }}
                        animate={{
                          width: inCart ? "33px" : "0px",
                          padding: inCart ? "0 14px 0 10px" : "0",

                          visibility: inCart ? "visible" : "hidden",
                        }}
                        transition={{ duration: 0.2, type: "tween" }}
                        className="product-page__remove-btn"
                        type="button"
                        ref={removeCartRef}
                        onClick={removeFromCart}
                      >
                        <CrossIcon
                          mainClassName={"product-page__remove-icon"}
                          fillClassName={"product-page__remove-icon-fill"}
                        />
                      </motion.button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {product.parameters && product.parameters.length > 0 ? (
              <div className="product-page__parameters">
                <div className="product-page__column">
                  {product?.parameters
                    ?.filter((item2) => item2.name !== ARTICL_NAME)
                    .filter((param) => !param.name.startsWith('_'))
                    .filter((item2) => item2.name !== 'Capacity')
                    .filter((item2) => item2.name !== 'Condition')
                    .filter((item2) => item2.name !== 'Артикул')
                    .slice(0, Math.ceil(product?.parameters
                      ?.filter((item2) => item2.name !== ARTICL_NAME)
                      .filter((param) => !param.name.startsWith('_'))
                      .filter((item2) => item2.name !== 'Capacity')
                      .filter((item2) => item2.name !== 'Condition')
                      .filter((item2) => item2.name !== 'Артикул').length / 2))
                    .map((parameter, i) => (
                      <div
                        className="product-page__parameter"
                        key={`${product._id}_parameter_${i}`}
                      >
                        <h4 className="product-page__parameter-title">
                          {parameter.name}
                        </h4>
                        <p className="product-page__parameter-value">
                          {parseParameterValue(parameter)}
                        </p>
                      </div>
                    ))}
                </div>

                <div className="product-page__divider"></div> {/* Разделитель */}

                <div className="product-page__column">
                  {product?.parameters
                    ?.filter((item2) => item2.name !== ARTICL_NAME)
                    .filter((param) => !param.name.startsWith('_'))
                    .filter((item2) => item2.name !== 'Capacity')
                    .filter((item2) => item2.name !== 'Condition')
                    .filter((item2) => item2.name !== 'Артикул')
                    .slice(Math.ceil(product?.parameters
                      ?.filter((item2) => item2.name !== ARTICL_NAME)
                      .filter((param) => !param.name.startsWith('_'))
                      .filter((item2) => item2.name !== 'Capacity')
                      .filter((item2) => item2.name !== 'Condition')
                      .filter((item2) => item2.name !== 'Артикул').length / 2))
                    .map((parameter, i) => (
                      <div
                        className="product-page__parameter"
                        key={`${product._id}_parameter_${i}`}
                      >
                        <h4 className="product-page__parameter-title">
                          {parameter.name}
                        </h4>
                        <p className="product-page__parameter-value">
                          {parseParameterValue(parameter)}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            ) : null}
            <InfoLine />
            {console.log(recentlyViewArray.filter((item) => item._id !== item_id))}
            {recentlyViewArray.length > 0 && recentlyViewArray.filter((item) => item._id !== item_id).length > 0 ?
              <div className="product-page__recently-view">
                <p className="product-page__recently-view__title">Recently Viewed Items</p>
                <div className="product-page__recently-view__items">
                  {recentlyViewArray.filter((item) => item._id !== item_id)
                    .reverse() // Реверсируем массив
                    .slice(0, visibleCount) // Ограничиваем количество видимых карточек
                    .map((item, index) => (
                      <ProductCardHero key={index} item={item} />
                    ))}
                </div>
                {recentlyViewArray.filter((item) => item._id !== item_id).length > visibleCount && (
                  <div className="product-page__recently-view__btn-box">
                    <button className="product-page__recently-view__btn" onClick={loadMore}>
                      View all {recentlyViewArray.filter((item) => item._id !== item_id).length}
                    </button>
                    <svg className="product-page__recently-view__btn__line" xmlns="http://www.w3.org/2000/svg" width="1200" height="2" viewBox="0 0 1200 2" fill="none">
                      <path d="M1200 0.999895L0 1" stroke="#D4D4D4" />
                    </svg>
                  </div>
                )}
              </div>
              : null}
            {promotedProducts && promotedProducts.length > 0 && promotedProducts.filter((item) => item._id !== item_id).length > 0 && recentlyViewArray && promotedProducts.filter((item) => !recentlyViewArray.some((promoted) => promoted._id === item._id)).length > 0 ?
              <div className="product-page__recently-view">
                <p className="product-page__recently-view__title">Related products</p>
                <div className="product-page__recently-view__items">
                  {promotedProducts.filter((item) => item._id !== item_id).filter((item) => !recentlyViewArray.some((promoted) => promoted._id === item._id))
                    .reverse() // Реверсируем массив
                    .slice(0, visibleCount) // Ограничиваем количество видимых карточек
                    .map((item, index) => (
                      <ProductCardHero key={index} item={item} />
                    ))}
                </div>

              </div>
              : null}
          </div>
        </div>
      ) : (
        <div className="product-page__not-found">
          <NotFoundBlock
            text={
              "<h2>404</h2><br/>It seems that you tried to open a product that has not yet arrived for sale"
            }
            goToMain={true}
          />
        </div>
      )}
      <FullScreen initialIndex={my_swiper && my_swiper.realIndex} isOpen={isFull} setOpen={setFull} product={product} onClose={() => { setFull(false)}} showThumbs />
    </>
  );
}

export default ProductPage;
